import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[enterKeyAction]',
  standalone: true,
})
export class EnterKeyDownDirective {
  @Input() enterKeyAction!: () => void;
  @Input() isLoading = false;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !this.isLoading) {
      this.enterKeyAction();
    }
  }
}
